import request from '../utils/request';

//宣传资料列表
export function travelBrochureList(data) {
  return request({
    url: '/frontExhibitor/travelBrochure/list',
    method: 'get',
    params: data,
  });
}

// 新增宣传资料/修改
export function addTravel(data) {
  return request({
    url: '/frontExhibitor/travelBrochure/saveOrEdit',
    method: 'post',
    data: data,
  });
}
// 获取单个宣传资料记录
export function getTravelBrochure(data) {
  return request({
    url: '/frontExhibitor/travelBrochure/view',
    method: 'get',
    params: data,
  });
}

// 删除单个宣传资料记录
export function delTravelBrochure(data) {
  return request({
    url: '/frontExhibitor/travelBrochure/delete',
    method: 'get',
    params: data,
  });
}
// 修改列表排序
export function updateSort(data) {
  return request({
    url: '/frontExhibitor/travelBrochure/editSort',
    method: 'get',
    params: data,
  });
}
